import { useCallback } from "react";
import { useNotify } from "react-admin";

import type { DialRecord, DialResult } from "../../lib/telephony/phoneEngine";
import { usePhone } from "./PhoneProvider";

/** Dials through the portal phone and tells the agent why a call did not start. */
export const useDialNumber = (): ((number: string, record?: DialRecord) => Promise<DialResult>) => {
  const notify = useNotify();
  const { dial } = usePhone();

  return useCallback(
    async (number: string, record?: DialRecord) => {
      const result = await dial(number, record);
      if (result.ok) return result;
      if (result.reason === "invalidNumber") notify("telephony.call.invalidNumber", { type: "error" });
      else if (result.reason === "microphone") notify("telephony.call.microphoneBlocked", { type: "error" });
      else if (result.reason === "failed") notify("telephony.call.failed", { type: "error" });
      return result;
    },
    [dial, notify]
  );
};
